import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNaN } from 'lodash';

import { currencyFormatter,  percentageFormatter } from 'utils';
import { Label, InfoMessage } from 'components';
import { useSelector } from 'react-redux';
import CurrencyInput from 'react-currency-input-field';

const NumberFieldWithDecimals = ({
  label,
  containerClassName,
  percentage = false,
  simple = false,
  currency = false,
  value,
  onChange,
  infoMessage,
  infoMessageClassName,
  autoFormat,
  className,
  id,
  right = false,
  asterisk = false,
  suffix = '',
  ...rest
}) => {

   
  return (
    <div className={containerClassName || ''}>
      <div className="d-flex">
        <Label label={label} asterisk={asterisk} />
        <InfoMessage
          infoMessage={infoMessage}
          overlayClassName={infoMessageClassName}
        />
      </div>
      {/* <Input
        {...rest}
        onChange={v=> checkInput(v)}
        value={viewMode && formattedValue && !autoFormat ? (isNaN(formattedValue)? currencyFormatter(formattedValue.replaceAll(',','.')):currencyFormatter(parseFloat(formattedValue.replaceAll(',','.')))):formattedValue}
        onBlur={v=> autoFormat == false || isNil(autoFormat) ? formatNumber(v.target.value):''}
        onClick={()=>autoFormat == false || isNil(autoFormat) ? setFormattedValue(realValue):''}
      /> */}
      
      <CurrencyInput className={`ant-input ant-input-lg ${right ? "formattedNumberField" : ""}`}
        id={id}
        name="input-name"
        decimalsLimit={rest.decimalsLimit} // Limit length of decimals allowed
        decimalScale={rest.decimalScale} // Specify decimal scale for padding/trimming eg. 1.5 -> 1.50
        fixedDecimalLength={rest.fixedDecimalLength} // Value will always have the specified length of decimals
        allowNegativeValue={false} 
        value={value}
        groupSeparator={'.'}
        decimalSeparator={','}
        onValueChange={(value, name) =>onChange(value)}
        suffix={suffix}
        placeholder={rest.placeholder}
        disabled={rest.disabled}
        />

    </div>
  );
};

NumberFieldWithDecimals.propTypes = {
  label: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  value: PropTypes.number.isRequired,
  percentage: PropTypes.bool,
  simple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default NumberFieldWithDecimals;
